var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownTurnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 45,
    viewBox: "0 0 31 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73626 5.90029C1.22277 5.90029 0 4.67133 0 3.15016C0 1.62899 1.22277 0.400024 2.73626 0.400024H10.945C15.477 0.400024 19.1538 4.09552 19.1538 8.65043V35.0087L25.4301 28.7006C26.499 27.6264 28.2348 27.6264 29.3036 28.7006C30.3725 29.7749 30.3725 31.5195 29.3036 32.5938L18.3586 43.5943C17.2897 44.6686 15.5539 44.6686 14.4851 43.5943L3.54003 32.5938C2.47118 31.5195 2.47118 29.7749 3.54003 28.7006C4.60889 27.6264 6.3447 27.6264 7.41355 28.7006L13.6813 35.0087V8.65043C13.6813 7.12926 12.4585 5.90029 10.945 5.90029H2.73626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTurnArrow);
export default __webpack_public_path__ + "static/media/down-turn-arrow.830b78fba0db400ab6eb31c02c006780.svg";
export { ForwardRef as ReactComponent };